import { mode } from '@chakra-ui/theme-tools';

const disable = (props) => ({
  _disabled: {
    opacity: '1 !important',
    bg: '#0F1426 !important',
    color: '#4C505C !important',
    _hover: {
      bg: '#0F1426 !important',
    },
    _active: {
      bg: '#0F1426 !important',
    },
    'svg > path': {
      color: '#4C505C !important', 
    }
  },
});

const baseStyle = (props) => ({
  fontSize: '16px !important',
  w: '100% !important',
  color: mode('#0E1633 !important', 'white !important')(props),
  borderRadius: '16px !important',
  fontWeight: '600',
  lineHeight: '21px',
  letterSpacing: '-0.4px',
  ...disable
});

const buttonStyle = (props) => ({
  ...baseStyle,
  color: 'white !important',
  bg: 'linear-gradient(180deg, #2ABDFD 0%, #0497FD 100%) !important',
  _hover: {
    bg: 'linear-gradient(180deg, #009EEA 0%, #009EEA 100%) !important',
  },
  _active: {
    bg: 'linear-gradient(180deg, #2ABDFD 0%, #0497FD 100%) !important',
  },
  _focus: {
    outline: 'unset',
    boxShadow: 'unset'
  }
});

const secondaryStyle = (props) => ({
  ...baseStyle,
  bg: mode('white !important', '#0E1633 !important')(props),
  _hover: {
    bg: mode('#ffffffbd !important', '#0D234D !important')(props),
  },
  _active: {
    bg: mode('white !important', '#0E1633 !important')(props),
  },
  _focus: {
    outline: 'unset',
    boxShadow: 'unset'
  }
});

const secondaryInvertedStyle = (props) => ({
  ...baseStyle,
  bg: mode('#F1F4FF !important', '#0D234D !important')(props),
  _hover: {
    bg: mode('#F1F4FF !important', '#0D234D !important')(props),
  },
  _active: {
    bg: mode('#F1F4FF !important', '#0D234D !important')(props),
  },
  _focus: {
    outline: 'unset',
    boxShadow: 'unset'
  }
});

const solidStyle = (props) => ({
  ...baseStyle,
  border: '1px solid #2ABDFD',
  backdropFilter: 'blur(2.6px)',
  _hover: {
    bg: 'rgba(9, 155, 255, 0.10) !important',
    /*svg: {
      path: {
        fill: 'white !important'
      }
    }*/
  },
  _active: {
    bg: 'transparent !important',
  },
  _focus: {
    outline: 'unset',
    boxShadow: 'unset'
  },
  svg: {
    path: {
      fill: mode('#0E1633', 'white')(props)
    }
  }
});

const deleteStyle = (props) => ({
  ...baseStyle,
  border: '1px solid #FF6C64',
  backdropFilter: 'blur(2.6px)',
  color: '#FF6C64',
  _hover: {
    bg: 'transparent !important',
  },
  _active: {
    bg: 'transparent !important',
  },
  _focus: {
    outline: 'unset',
    boxShadow: 'unset'
  }
});

const ghostStyle = (props) => ({
  ...baseStyle,
  border: 'unset !important',
  backdropFilter: 'unset !important',
  bg: 'transparent !important',
  _hover: {
    bg: 'transparent !important',
  },
  _active: {
    bg: 'transparent !important',
  },
  _focus: {
    outline: 'unset',
    boxShadow: 'unset'
  }
});

const stylesLg = {
  h: '56px !important',
  p: '5px 10px !important',
};

const stylesMd = {
  h: '44px !important',
  p: '5px 10px !important',
};

const stylesSm = {
  h: '36px !important',
  p: '8px !important',
};

const shadowStyle = {
  boxShadow: '0px 1px 22.4px 0px rgba(9, 155, 255, 0.60)'
};

export const buttonStyles = {
  components: {
    Button: {
      variants: {
        'button-lg': (props) => ({...buttonStyle(props), ...stylesLg}),
        'button-md': (props) => ({...buttonStyle(props), ...stylesMd}),
        'button-sm': (props) => ({...buttonStyle(props), ...stylesSm}),
        'button-lg-g': (props) => ({...buttonStyle(props), ...stylesLg, ...shadowStyle}),
        'button-md-g': (props) => ({...buttonStyle(props), ...stylesMd, ...shadowStyle}),
        'button-sm-g': (props) => ({...buttonStyle(props), ...stylesSm, ...shadowStyle}),
        'secondary-lg': (props) => ({...secondaryStyle(props), ...stylesLg}),
        'secondary-md': (props) => ({...secondaryStyle(props),...stylesMd}),
        'secondary-sm': (props) => ({...secondaryStyle(props), ...stylesSm}),
        'secondary-inverted-lg': (props) => ({...secondaryInvertedStyle(props), ...stylesLg}),
        'secondary-inverted-md': (props) => ({...secondaryInvertedStyle(props),...stylesMd}),
        'secondary-inverted-sm': (props) => ({...secondaryInvertedStyle(props), ...stylesSm}),
        'solid-lg': (props) => ({...solidStyle(props), ...stylesLg}),
        'solid-md': (props) => ({...solidStyle(props),...stylesMd}),
        'solid-sm': (props) => ({...solidStyle(props), ...stylesSm}),
        'ghost-lg': (props) => ({...ghostStyle(props), ...stylesLg}),
        'ghost-md': (props) => ({...ghostStyle(props),...stylesMd}),
        'ghost-sm': (props) => ({...ghostStyle(props), ...stylesSm}),
        'delete-lg': (props) => ({...deleteStyle(props), ...stylesLg}),
        'delete-md': (props) => ({...deleteStyle(props),...stylesMd}),
        'delete-sm': (props) => ({...deleteStyle(props), ...stylesSm}),
        'menuitem': {
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: '400',
          color: 'blue.900',
          mx: '-5px',
          px: '0',
          mb: '-2px',
          mt: '-2px',
          _focus: {
            bg: 'transparent !important',
          },
          _hover: {
            bg: 'transparent !important',
          },
          _active: {
            bg: 'transparent !important',
          }
        }
      },
      baseStyle
    }
  }
};
